import { useExplorer } from "@/context/ExplorerContext";
import { DiplomaCard } from "@/components/lurio/DiplomaCard";
import { Eyebrow, Section, Hand, Fr } from "@/components/lurio/Primitives";
import { Reveal } from "@/components/lurio/Motion";

export default function Diplome() {
  const { t } = useExplorer();
  const d = t.diploma;
  const [before, after] = d.body.split("Diplôme d'Explorateur");
  return (
    <Section id="diplome">
      <div className="grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal><Eyebrow className="mb-5">{d.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl">{d.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-[1.08rem] leading-[1.85] text-ink-soft sm:text-lg">
              {before}<Fr className="font-semibold text-ink">Diplôme d'Explorateur</Fr>{after}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p data-testid="diploma-preview-note" className="mt-5 inline-block rounded-xl bg-sage-soft px-4 py-2 text-sm font-semibold text-ink">{d.previewNote}</p>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="relative lg:col-span-6">
          <DiplomaCard stamp className="rotate-[-1.5deg]" />
          <Hand className="absolute -bottom-7 start-6 text-xl sm:text-2xl" rotate={2} tone="text-pencil">{d.hand}</Hand>
        </Reveal>
      </div>
    </Section>
  );
}
